import { isTextField as l, getDocument as s } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
function c(t, n) {
  return t.find((e) => !e.disabled);
}
function d(t, n) {
  return n && t.item(n) || null;
}
function a(t) {
  const n = [];
  for (const e of t) {
    const i = n.find((u) => {
      var o;
      return ((o = u[0]) == null ? void 0 : o.rowId) === e.rowId;
    });
    i ? i.push(e) : n.push([e]);
  }
  return n;
}
function S(t, n = !1) {
  if (l(t))
    t.setSelectionRange(
      n ? t.value.length : 0,
      t.value.length
    );
  else if (t.isContentEditable) {
    const e = s(t).getSelection();
    e == null || e.selectAllChildren(t), n && (e == null || e.collapseToEnd());
  }
}
var r = Symbol("FOCUS_SILENTLY");
function I(t) {
  t[r] = !0, t.focus({ preventScroll: !0 });
}
function v(t) {
  const n = t[r];
  return delete t[r], n;
}
function g(t, n, e) {
  return !(!n || n === e || !t.item(n.id));
}
export {
  c as findFirstEnabledItem,
  I as focusSilently,
  d as getEnabledItem,
  a as groupItemsByRows,
  g as isItem,
  S as selectTextField,
  v as silentlyFocused
};
//# sourceMappingURL=5VQZOHHZ.js.map
